var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._t("header")],2),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('calendar-view',{attrs:{"schedules":_vm.items,"type":_vm.type,"loading":_vm.loading,"show-details":"","hide-selections":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }